import { render, staticRenderFns } from "./RolesDetailsForm.vue?vue&type=template&id=d4d5f538&"
import script from "./RolesDetailsForm.vue?vue&type=script&lang=js&"
export * from "./RolesDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports